import { createStyles } from '@mantine/core'

export const useStyles = createStyles((theme) => ({
    addingNewReleaseButton: {},
}))
